// Lyrics data with timestamps for each song
export const songLyrics = [
  {
    title: "Mr Perfect - Perfectionism",
    soundSource:"https://remind-public.s3.eu-north-1.amazonaws.com/songs/67d593f30e1753d80f32fc62",
    _id: "67d593f30e1753d80f32fc62",
    //soundSource: "/songs/MR PERFECT - PERFECTIONISM.mp3",
    lyrics: [
      { time: 0, text: "Mr. Perfect - A song about Perfectionism" },
      { time: 9, text: "Why do I need to be perfect" },
      { time: 17, text: "For whom do I feel this way" },
      { time: 23, text: "Is it for myself" },
      { time: 27, text: "Or someone else" },
      { time: 33, text: "What happens if I fail" },
      { time: 41, text: "What goes on the line" },
      { time: 47, text: "Is it my name, my life, my need to shine" },
      { time: 56, text: "Will I be judged if I stumble" },
      { time: 61, text: "Will I get hurt if I fall" },
      { time: 65, text: "Will I be thought a lot less of" },
      { time: 69, text: "If I brave to show all" },
      { time: 73, text: "All of my scars and my weaknesses" },
      { time: 77, text: "Cause you know I'm not always that strong" },
      { time: 82, text: "And sometimes I cry when I feel so wrong" },
      { time: 89, text: "For not being Mr. Perfect" },
      { time: 95, text: "I allow darkness to sit in" },
      { time: 100, text: "And life passes me by" },
      { time: 104, text: "Stuck in the web of perfection" },
      { time: 107, text: "Nothing's good enough" },
      { time: 111, text: "It's loud and demeaning" },
      { time: 115, text: "These feelings of dreadf" },
      { time: 119, text: "I long for this weight to be lifted" },
      { time: 122, text: "To allow my wings to spread" },
      { time: 127, text: "Will I be judged if I stumble" },
      { time: 131, text: "Will I get hurt if I fall" },
      { time: 135, text: "Will I be thought a lot less of" },
      { time: 139, text: "If I brave to show all" },
      { time: 143, text: "All of my scars and my weaknesses" },
      { time: 148, text: "Cause you know I'm not always that strong" },
      { time: 152, text: "And sometimes I cry when I feel so wrong" },
      { time: 159, text: "For not being Mr. Perfect" },
      { time: 164, text: "Open the door " },
      { time: 167, text: "To new perceptions" },
      { time: 173, text: "To keep moving" },
      { time: 175, text: "in the right direction" },
      { time: 181, text: "Glad to be flawed" },
      { time: 184, text: "In my Imperfections" },
      { time: 189, text: "I am perfectly flawed" },
      { time: 192, text: "In my Imperfections" },
      { time: 197, text: "Will I be judged if I stumble" },
      { time: 201, text: "Will I get hurt if I fall" },
      { time: 205, text: "Will I be thought a lot less of" },
      { time: 209, text: "If I brave to show all" },
      { time: 214, text: "All of my scars and my weaknesses" },
      { time: 218, text: "Cause you know I'm not always that strong" },
      { time: 223, text: "And sometimes I cry when I feel so wrong" },
      { time: 230, text: "For not being Mr. Perfect" },
      { time: 234, text: "No, I'm not Mr. Perfect" },
      { time: 239, text: "I'll never be Mr. Perfect" },
      { time: 245, text: "Are you Ms. Perfect?" }
    ]
  },
  {
    title: "What If - Anxiety",
    _id: "67d594000e1753d80f32fc67",
    //soundSource: "/songs/WHAT IF - ANXIETY AND BARGAINING.mp3",
    soundSource: "https://remind-public.s3.eu-north-1.amazonaws.com/songs/67d594000e1753d80f32fc67",
    lyrics: [
      { time: 0, text: "What If - A song about anxiety and bargaining" },
      { time: 11, text: "What if I fail" },
      { time: 15, text: "And this doesn't work out" },
      { time: 19, text: "What if it doesn't come true" },
      { time: 23, text: "And there's no going back" },
      { time: 27, text: "What if I make a fool of myself" },
      { time: 31, text: "And my house of cards tumbles down" },
      { time: 35, text: "And my body and mind don't follow" },
      { time: 39, text: "Will it be a hard pill to swallow?" },
      { time: 44, text: "What if I could change course" },
      { time: 47, text: "By being the red rose in the white rose garden" },
      { time: 51, text: "What if I could change chords" },
      { time: 55, text: "By being the judge and deliver my pardon" },
      { time: 59, text: "What if this changes my life forever" },
      { time: 64, text: "What If I could Let it go" },
      { time: 71, text: "What If I could Let it be" },
      { time: 79, text: "As it needs to be" },
      { time: 83, text: "And Let it flow" },
      { time: 87, text: "Fast or slow" },
      { time: 91, text: "till it shows" },
      { time: 96, text: "Its true purpose" },
      { time: 104, text: "What if I start" },
      { time: 108, text: "What if I leap" },
      { time: 112, text: "What if I succeed" },
      { time: 116, text: "And I have to go on" },
      { time: 120, text: "What if tomorrow never comes" },
      { time: 124, text: "What if this is my last chance" },
      { time: 128, text: "What if is all in my head," },
      { time: 132, text: "Swirling around" },
      { time: 136, text: "What if I could cut the cord" },
      { time: 141, text: "Can I brave to look inside all of my mirrors" },
      { time: 143, text: "What if I could cut loose" },
      { time: 149, text: "Embrace the reflections and become the seer" },
      { time: 152, text: "What if this changes my life forever" },
      { time: 157, text: "What If I could Let it go" },
      { time: 164, text: "What If I could Let it be" },
      { time: 172, text: "As it needs to be" },
      { time: 176, text: "And Let it fly" },
      { time: 180, text: "Laugh or cry" },
      { time: 184, text: "Wait till it sighs" },
      { time: 189, text: "Its new purpose" },
      { time: 197, text: "What if I can be my whole self" },
      { time: 201, text: "And embrace my whole truth" },
      { time: 205, text: "What if I can make it and stand," },
      { time: 209, text: "Stand here as proof" },
      { time: 213, text: "What if I dropped the what if at the end" },
      { time: 217, text: "And understand" },
      { time: 220, text: "That I've always been more than enough" },
      { time: 229, text: "Have I always been more than enough?" },
      { time: 237, text: "That I've always been more than enough" },
      { time: 245, text: "Have I always been more than enough?" }
    ]
  },
  {
    title: "As Far As It Takes - Grief",
    _id: "67d5940b0e1753d80f32fc6c",
    //soundSource: "/songs/AS FAR AS IT TAKES - GRIEF.mp3",
    soundSource: "https://remind-public.s3.eu-north-1.amazonaws.com/songs/67d5940b0e1753d80f32fc6c",
    lyrics: [
      { time: 0, text: "As Far As It Takes - A song about grief and loss" },
      { time: 21, text: "When a pillar goes" },
      { time: 27, text: "The earth shakes" },
      { time: 33, text: "The thunder strikes" },
      { time: 38, text: "May you walk" },
      { time: 42, text: "As far as it takes" },
      { time: 47, text: "May you walk" },
      { time: 51, text: "As far as it takes" },
      { time: 55, text: "What I've known is gone" },
      { time: 59, text: "Feeling alone, left behind" },
      { time: 64, text: "Heart veiled in darkness" },
      { time: 69, text: "Drowning in sadness" },
      { time: 73, text: "Will memories lead to light?" },
      { time: 78, text: "All life stands still now" },
      { time: 83, text: "Lost to who I am" },
      { time: 87, text: "I let the pressure shape me" },
      { time: 91, text: "Turning grief to love" },
      { time: 95, text: "Turning grief to love" },
      { time: 98, text: "Lost to who I am" },
      { time: 102, text: "I let the pressure shape me" },
      { time: 105, text: "Turning grief to love" },
      { time: 109, text: "Turning grief to love" },
      { time: 113, text: "All the life we spent" },
      { time: 117, text: "Seems like a moment, gone by" },
      { time: 122, text: "How can I let go" },
      { time: 128, text: "Condensed in my tears" },
      { time: 132, text: "Is the courage to begin" },
      { time: 136, text: "The tunnel's light shines" },
      { time: 141, text: "Lost to who I am" },
      { time: 146, text: "I let the pressure shape me" },
      { time: 149, text: "Turning grief to love" },
      { time: 152, text: "Turning grief to love" },
      { time: 156, text: "Lost to who I am" },
      { time: 160, text: "I let the pressure shape me" },
      { time: 163, text: "Turning grief to love" },
      { time: 167, text: "Turning grief to love" },
      { time: 170, text: "I wanna learn again how to feel grateful" },
      { time: 175, text: "Even if it takes so much of mine" },
      { time: 178, text: "As long as I'm alive I'll hold the connection" },
      { time: 183, text: "To keep it nourished till the end of time" },
      { time: 185, text: "Nobody really knows how to go through it" },
      { time: 189, text: "No-one really knows what happens next" },
      { time: 193, text: "And yet we all have to find a way to get past it" },
      { time: 197, text: "Cause we are all heading to the endless rest" },
      { time: 200, text: "Lost to who I am" },
      { time: 204, text: "I let the pressure shape me" },
      { time: 207, text: "Turning grief to love" },
      { time: 210, text: "I'm turning grief to love" },
      { time: 214, text: "Lost to who I am" },
      { time: 218, text: "I let the pressure shape me" },
      { time: 221, text: "Turning grief to love" },
      { time: 225, text: "Turning grief to love" },
      { time: 243, text: "When a pillar goes" },
      { time: 249, text: "The earth shakes" },
      { time: 255, text: "The thunder strikes" },
      { time: 260, text: "May you walk" },
      { time: 264, text: "As far as it takes" },
      { time: 269, text: "May you walk" },
      { time: 273, text: "As far as it takes" }
    ]
  }
]
